import React from 'react';
import { Navigate } from 'react-router-dom';
import { useRestaurantAuth } from '../contexts/RestaurantAuthContext';

const RestaurantProtectedRoute = ({ children }) => {
    const { isAuthenticated, loading } = useRestaurantAuth();

    console.log('🔐 RestaurantProtectedRoute - Simple check:', { isAuthenticated, loading });

    if (loading) {
        console.log('🔄 RestaurantProtectedRoute - Still loading...');
        return (
            <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600"></div>
                <p className="mt-4 text-gray-600">Chargement...</p>
            </div>
        );
    }

    if (!isAuthenticated) {
        console.log('❌ RestaurantProtectedRoute - Not authenticated, redirect to login');
        return <Navigate to="/business/login" replace />;
    }

    console.log('✅ RestaurantProtectedRoute - Authenticated, show content');
    return children;
};

export default RestaurantProtectedRoute; 